import { useEffect, useRef, useState } from 'react';

// Ctrl/Cmd +/- page zoom changes window.devicePixelRatio (unlike trackpad
// pinch-zoom, which only affects window.visualViewport.scale). We capture
// the ratio present when the learner opens the chapter as the baseline —
// there's no reliable cross-display way to know "true" 100%, since a
// Retina screen is legitimately devicePixelRatio 2 at 100% zoom — and warn
// only if it drifts away from that baseline during the session.
export function useZoomWarning(): boolean {
  const baselineDprRef = useRef(window.devicePixelRatio);
  const [zoomedDifferently, setZoomedDifferently] = useState(false);

  useEffect(() => {
    let mql: MediaQueryList | null = null;
    function onChange() {
      attach();
    }
    function attach() {
      const dpr = window.devicePixelRatio;
      setZoomedDifferently(Math.abs(dpr / baselineDprRef.current - 1) > 0.02);
      mql?.removeEventListener('change', onChange);
      mql = matchMedia(`(resolution: ${dpr}dppx)`);
      mql.addEventListener('change', onChange);
    }
    attach();
    return () => mql?.removeEventListener('change', onChange);
  }, []);

  return zoomedDifferently;
}
